export const activityHistoryColumns = [
  {
    name_of_db_column: 'id',
    label_of_column: 'Event ID',
    sortable: true,
    filterable: false,
    width: '120px'
  },
  {
    name_of_db_column: 'activityName',
    label_of_column: 'Activity',
    sortable: true,
    filterable: false,
    width: '150px'
  },
  {
    name_of_db_column: 'pointsAwarded',
    label_of_column: 'Points',
    sortable: true,
    filterable: false,
    width: '100px'
  },
  {
    name_of_db_column: 'endpointBalance',
    label_of_column: 'Balance Points',
    sortable: true,
    filterable: false,
    width: '130px'
  },
  {
    name_of_db_column: 'type',
    label_of_column: 'Points Type',
    sortable: true,
    filterable: false,
    width: '120px'
  },
  {
    name_of_db_column: 'description',
    label_of_column: 'Description',
    sortable: true,
    filterable: false,
    width: '200px'
  },
  {
    name_of_db_column: 'createdAt',
    label_of_column: 'Creation Date',
    sortable: true,
    filterable: false,
    width: '150px'
  }
];
